import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleDown } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { Checkbox } from "@air/primitive-checkbox";
import { SelectDropdownMenu } from "@air/primitive-dropdown-menu";
import { memo, useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { centralizedClipPDFNumberOfPagesSelector } from "~/store/centralizedClip/selectors";
export const SharePrivateClipPDFPage = /*#__PURE__*/ memo((param)=>{
    let { onSelectPage } = param;
    const [selectedPage, setSelectedPage] = useState({
        id: "1",
        label: "1",
        type: "item"
    });
    const [showPage, setShowPage] = useState(false);
    const pdfNumberOfPages = useSelector(centralizedClipPDFNumberOfPagesSelector);
    const options = useMemo(()=>{
        if (!pdfNumberOfPages) return;
        return Array.from({
            length: pdfNumberOfPages
        }, (_, index)=>{
            const page = (index + 1).toString();
            return {
                canSelect: true,
                id: page,
                label: page,
                type: "item"
            };
        });
    }, [
        pdfNumberOfPages
    ]);
    const onSelect = useCallback((option)=>{
        setSelectedPage(option);
        onSelectPage(parseInt(option.id));
    }, [
        onSelectPage
    ]);
    const onToggle = useCallback((value)=>{
        setShowPage(!!value);
        if (!value) {
            onSelectPage(undefined);
        } else {
            onSelectPage(parseInt(selectedPage.id));
        }
    }, [
        onSelectPage,
        selectedPage
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-6 items-center gap-2 text-14 text-grey-12",
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                id: "share-private-clip-pdf",
                onCheckedChange: onToggle,
                "data-testid": "SHARE_PRIVATE_CLIP_PDF_PAGE_CHECKBOX"
            }),
            /*#__PURE__*/ _jsxs("label", {
                htmlFor: "share-private-clip-pdf",
                children: [
                    "Start at specific page",
                    showPage && ":"
                ]
            }),
            showPage && /*#__PURE__*/ _jsx(SelectDropdownMenu, {
                "data-testid": "SHARE_PRIVATE_CLIP_PDF_PAGE_SELECT",
                selectedOption: selectedPage,
                options: options,
                trigger: (selectedOption)=>/*#__PURE__*/ {
                    var _selectedOption_id;
                    return _jsx(Button, {
                        "data-testid": "SHARE_PRIVATE_CLIP_PAGE_SELECT_TRIGGER",
                        appearance: "ghost",
                        color: "grey",
                        suffix: /*#__PURE__*/ _jsx(TriangleDown, {
                            className: "size-4"
                        }),
                        size: "medium",
                        children: (_selectedOption_id = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) !== null && _selectedOption_id !== void 0 ? _selectedOption_id : "Select page"
                    });
                },
                onSelect: onSelect,
                size: "small"
            })
        ]
    });
});
SharePrivateClipPDFPage.displayName = "SharePrivateClipPDFPage";
